async function init(manifest) {
  const {
    bundles: rawBundles,
    width,
    height,
    offsetX = 0,
    offsetY = 0,
  } = manifest;

  class Sprite extends PIXI.Sprite {
    constructor(texture) {
      super(texture);
      this.width = width - 2 * offsetX;
      this.height = height - 2 * offsetY;
      this.x = offsetX;
      this.y = offsetY;
    }
  }

  class AnimatedSprite extends PIXI.AnimatedSprite {
    constructor(textures) {
      super(textures);
      this.width = width - 2 * offsetX;
      this.height = height - 2 * offsetY;
      this.x = offsetX;
      this.y = offsetY;
    }

    fadeIn(duration) {
      const ticker = PIXI.Ticker.shared;

      const listener = (delta) => {
        this.alpha += delta / (duration / 1000);

        if (this.alpha > 1) {
          ticker.remove(listener);
        }
      };

      ticker.add(listener);
    }

    fadeOut(duration) {
      const ticker = PIXI.Ticker.shared;

      const listener = (delta) => {
        this.alpha -= delta / (duration / 1000);

        if (this.alpha < 0) {
          ticker.remove(listener);
        }
      };

      ticker.add(listener);
    }
  }

  const bundles = rawBundles.map(
    ({ name, root: assetsRoot, assets: rawAssets }) => {
      const assets = rawAssets
        .map(({ name, srcs, frames, startIndex = 1 }) => {
          if (frames) {
            let animatedAssets = [];

            for (let j = 0; j < frames; j++) {
              animatedAssets.push({
                name: `${name}-${startIndex + j}`,
                srcs: `${assetsRoot}${srcs.replace('*', startIndex + j)}`,
              });
            }

            return animatedAssets;
          }

          return [
            {
              name,
              srcs: `${assetsRoot}${srcs}`,
            },
          ];
        })
        .reduce((acc, val) => [...acc, ...val], []);
      return { name, assets };
    }
  );

  // initialize Asset loader
  await PIXI.Assets.init({
    manifest: {
      bundles,
    },
  });

  // initialize Pixi instance
  const app = new PIXI.Application({
    width,
    height,
  });

  // and append PIXI canvas to document
  document.body.appendChild(app.view);

  // initialize Pixi asset loader

  const getAssetOfBundle = (bundleName, loadedBundle) => (name) => {
    const maybeRawBundle = rawBundles.find(
      (rawBundle) => rawBundle.name === bundleName
    );

    if (maybeRawBundle) {
      const { assets } = maybeRawBundle;

      const maybeAsset = assets.find((asset) => asset.name === name);

      if (maybeAsset) {
        if (maybeAsset.frames) {
          const { startIndex = 1 } = maybeAsset;
          let textures = [];
          for (let i = 0; i < maybeAsset.frames; i++) {
            textures.push(loadedBundle[`${name}-${startIndex + i}`]);
          }

          return textures;
        }

        return loadedBundle[name];
      }
    }

    return false;
  };

  return {
    app,
    getAssetOfBundle,
    Sprite,
    AnimatedSprite,
  };
}

export default init;
